import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {GetWarehouseHandlingUnitsResponse, GetWarehouseHandlingUnitResponse} from '../types';

const getHandlingUnitsMock: GetWarehouseHandlingUnitsResponse = [
  {
    id: 'bbc793ad-2b9d-4d0a-88a6-ae0cd6855409',
    name: 'ks',
    description: 'Kus / pieces',
    isDefault: true,
    isActive: true,
  },
  {
    id: '9869f85f-99fa-4e05-8cf6-7743f535cdca',
    name: 'Litres',
    description: 'Ltr',
    isDefault: false,
    isActive: true,
  },
  {
    id: 'a324d039-94b2-4b40-8298-b55cadb7c613',
    name: 'Pieces',
    description: 'Pcs',
    isDefault: false,
    isActive: true,
  },
  {
    id: '99e01877-cd09-4837-8c45-8b89db51bbde',
    name: 'Barrel 100 ltr',
    description: 'Brl100',
    isDefault: false,
    isActive: true,
  },
  {
    id: '61b90f92-20c6-461a-b41a-05e6a3e27d44',
    name: 'Test123',
    isDefault: false,
    isActive: true,
  },
  {
    id: '33de8ee3-a649-46b5-9a2e-45d26bf12b59',
    name: 'sdasd',
    isDefault: false,
    isActive: true,
  },
  {
    id: '8fa0520e-cada-438a-a715-6a8fb9b7f1af',
    name: 'Test123451',
    isDefault: false,
    isActive: true,
  },
  {
    id: '8ee88e94-986f-4260-8aaa-ba8c0b0c90da',
    name: 'Tesst',
    isDefault: false,
    isActive: true,
  },
  {
    id: 'caaa9e95-5b67-4609-903a-5a5332cb78f5',
    name: 'Test122',
    isDefault: false,
    isActive: true,
  },
  {
    id: '4db8a98f-e29d-4bf3-a937-8ae12006f7ad',
    name: 'Testt',
    isDefault: false,
    isActive: true,
  },
];

const getHandlingUnitsInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/codelist/wrh-handling-units', () => HttpResponse.json(getHandlingUnitsMock))
  );

const getHandlingUnitMock: GetWarehouseHandlingUnitResponse = {
  id: 'bbc793ad-2b9d-4d0a-88a6-ae0cd6855409',
  name: 'ks',
  description: 'Kus / pieces',
  isDefault: false,
  isActive: true,
};

const getHandlingUnitInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/codelist/wrh-handling-units/*', () =>
      HttpResponse.json(getHandlingUnitMock)
    )
  );

const postHandlingUnitInterceptor = (server: SetupServerApi) =>
  server.use(http.post('*/core/v1/codelist/wrh-handling-units', () => HttpResponse.json()));

const patchHandlingUnitInterceptor = (server: SetupServerApi) =>
  server.use(http.patch('*/core/v1/codelist/wrh-handling-units/*', () => HttpResponse.json()));

export const metadaWarehouseHandlingUnitApiMock = {
  getHandlingUnitsMock,
  getHandlingUnitsInterceptor,
  getHandlingUnitMock,
  getHandlingUnitInterceptor,
  postHandlingUnitInterceptor,
  patchHandlingUnitInterceptor,
};
